<div class="container">
  <h2 class="my-5">Things To Do</h2>

  <section class="row">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Snorkeling</h3>
      <p>
        Despite its role as the administrative center, Taniti City is closely connected to the natural environment
        that defines the island. Just minutes from the city center are several pristine beaches, including Yellow Leaf Bay,
        a popular destination for both leisure and local events.
      </p>
      <p>
        The city's coastal location provides opportunities for swimming, snorkeling, and guided eco-tours of nearby
        marine sanctuaries. Walking and cycling paths along the shoreline offer a peaceful retreat and scenic views
        of Taniti's natural landscapes.
      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row">
    <div class="col-md-9">
      <h3>Ziplining</h3>
      <p>
        Despite its role as the administrative center, Taniti City is closely connected to the natural environment
        that defines the island. Just minutes from the city center are several pristine beaches, including Yellow Leaf Bay,
        a popular destination for both leisure and local events.
      </p>
      <p>
        The city's coastal location provides opportunities for swimming, snorkeling, and guided eco-tours of nearby
        marine sanctuaries. Walking and cycling paths along the shoreline offer a peaceful retreat and scenic views
        of Taniti's natural landscapes.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

  <hr class="my-5">

  <section class="row">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Chartered Fishing Tours</h3>
      <p>
        Despite its role as the administrative center, Taniti City is closely connected to the natural environment
        that defines the island. Just minutes from the city center are several pristine beaches, including Yellow Leaf Bay,
        a popular destination for both leisure and local events.
      </p>
      <p>
        The city's coastal location provides opportunities for swimming, snorkeling, and guided eco-tours of nearby
        marine sanctuaries. Walking and cycling paths along the shoreline offer a peaceful retreat and scenic views
        of Taniti's natural landscapes.
      </p>
    </div>
  </section>
</div>
